












































































































































































































































    import { Component, Watch, RightHelper } from "../../../Infrastructure/CorBase/CoreBase";
	import CertificateDetailBase from "./CertificateDetailBase";

	@Component
	export default class CertificateDetail extends CertificateDetailBase {

        showDeleteDialog(isTenant: boolean) {
            this.isDeleteTenant = isTenant;
            this.showAllertToDeleteClick();
        }

        goBackNotChangeGlobal() {
            super.goBackNotChange();
            this.formIsInEditModeGlobal = false;
        }

        showAllertToCancelEditingClickGlobal() {
            //VaP - pokud bude nastaveno, ze se ma ptat a zmenila se data, tak zobrazime dotaz
            if (this.$store.state.askBeforeCancelEditing === true ) {
                this.showAlertModalById("alertModalIdToCancelEditingGlobal");
            }
            else {
                this.goBackNotChangeGlobal();
            }
        }

		///hlaska o prekroceni inputu po Ctrl+V
		private infoShortInput(maxLength: string): void {
			this.infoShortInputBase(maxLength);
        }

        disableTenant() {
            return this.passwordNeedGlobal || this.formIsInEditModeGlobal;
        }

        disableGlobal() {
            return this.passwordNeed || this.formIsInEditMode;
        }

        showSaveButtonMain(isTenant: boolean) {
            if (isTenant) {
            
                return this.formIsInEditMode || this.passwordNeed;
            }
            else {
                return this.formIsInEditModeGlobal || this.passwordNeedGlobal;
            }
        }

        showEditCertificate(isTenant: boolean) {
            return !this.showSaveButtonMain(isTenant) && this.showUpdateCertificate(isTenant);
        }

        showDeleteCertificate(isTenant: boolean) {
            return !this.showSaveButtonMain(isTenant) && this.showUpdateCertificate(isTenant);
        }

        showAddCertificate(isTenant: boolean) {
            if (isTenant) {
                return this.formData.id == 0 && !this.formIsInEditMode && !this.passwordNeed;
            }
            else {
                return this.formDataGlobal.id == 0 && !this.formIsInEditModeGlobal && !this.passwordNeedGlobal;
            }
        }

        showUpdateCertificate(isTenant: boolean) {
            if (isTenant) {
                return this.formData.id != 0 && !this.formIsInEditMode && !this.passwordNeed;
            }
            else {
                return this.formDataGlobal.id != 0 && !this.formIsInEditModeGlobal && !this.passwordNeedGlobal;
            }
        }


        goToDetailReceiver(id: number) {
            this.$router.push({ name: 'ReceiverDetail', params: { id: id.toString() }, query: { id: id.toString()} });
        }

        mounted() {
			super.mounted(true);
		};

		get gapDesign() {
			return {
				"gapTableDetail": true
			}
		}

		created() {			
            super.initializeRights('COR_Setting_Tenant', 'COR_Setting_Tenant', 'COR_Setting_Tenant', 'COR_Setting_Tenant');
            super.setMainDescription('certificate.detail', 'certificate.detail');
 		}
      
		validate(isTenant: boolean) {
            return this.validateBase(isTenant);
		}

		isCorrectName(value: any) {
			this.isCorrectNameBase(value);
        }

        isCorrectPassword(value: any) {
            this.isCorrectPasswordBase(value);
        }

        isCorrectNameGlobal(value: any) {
            this.isCorrectNameGlobalBase(value);
        }

        isCorrectPasswordGlobal(value: any) {
            this.isCorrectPasswordGlobalBase(value);
        }

        //@ts-ignore
		@Watch('$i18n.locale')
		changeLanguage(value: boolean, oldValue: boolean) {
			this.changeLanguageBase(value, oldValue);
		}
	}
